<div class="history-version-body">
  @if (versions.length > 0) {
    <label class="history-version-label" for="history-version-select">
      {{ 'CRM.LABEL.VERSION' | translate }}:
    </label>
    <p-select
      inputId="history-version-select"
      [options]="versions"
      optionLabel="label"
      optionValue="value"
      [placeholder]="'COMMON.LABEL.CHOOSE' | translate"
      [ngModel]="selectedVersion()"
      (ngModelChange)="selectedVersion.set($event)"
      appendTo="body"
      class="history-version-select"
    />
    <button
      pButton
      class="history-version-open"
      label="{{ 'COMMON.LABEL.BUTTONS.OPEN' | translate }}"
      (click)="openVersion()"
      [disabled]="selectedVersion() === null"
    ></button>
  } @else {
    <div [innerHTML]="'COMMON.LABEL.NO_AUDIT_INFO_MSG' | translate"></div>
  }
</div>
